import React, { useContext, useEffect } from "react";
import { Stack, Typography } from "@mui/material";
import { useState } from "react";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import MyIconButton from "../components/MyIconButton";
import ResultsTable from "./ResultsTable";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import { checkStateValues } from "./config";
import { get } from "lodash";
import { QuestionsContext, ReviewContext } from "../../../provider/MyContexts";
import ReviewDetailWindow from "./ReviewDetailWiindow";
import { Refresh } from "@mui/icons-material";
import { Question } from "../../../type";
import { getQuestionRange } from "../../../commands/questions/excelInfo";
import { focusCell } from "../../../commands/common";
import CommentDialog from "./elements/CommentDialog";
import { LoadingBox2 } from "../components/LoadingBox";

type Props = {
  // handleReview?: (sheet: string, step:number) => void;
};

export default function ReviewResults(props: Props) {
  const {} = props;

  const {
    reviews,
    reviewState,
    handleReviewState,
    downloadReviewResults,
    handleLLMReview,
    isExtraLoading,
    selectedId,
    reviewFiles,
  } = useContext(ReviewContext);
  const { questions, editSheet } = useContext(QuestionsContext);

  const overalCommannds = [
    {
      label: "再チェック",
      icon: <Refresh fontSize="small" />,
      clickFunction: () => handleReviewState(undefined),
      disabled: false,
    },
    {
      label: "ダウンロード",
      icon: <FileDownloadIcon fontSize="small" />,
      clickFunction: () => downloadReviewResults(reviewState),
      disabled: false,
    },
  ];

  if (reviewState === Object.keys(checkStateValues)[0]) {
    overalCommannds.push({
      label: "LLMチェック",
      icon: <FactCheckIcon fontSize="small" />,
      clickFunction: () => {
        if (!reviewFiles["llm"]) {
          handleLLMReview();
        } else {
          handleReviewState("llm");
        }
      },
      disabled: reviewFiles["excel"] && !reviewFiles["llm"],
    });
  }

  const doneLength = reviews[reviewState].filter((r) => r.done && !r.dismiss).length;
  const dismissLength = reviews[reviewState].filter((r) => r.dismiss).length;

  async function setFocusOnQuestion(question: Question, editSheet: string) {
    const questionIds = questions.map((q) => q.questionId);

    const targetIndex = questionIds.findIndex(
      (qId) => qId === question.questionId || qId === `Q${question.questionId}`
    );

    const nextQuestionId =
      targetIndex <= questionIds.length - 1 ? questionIds[targetIndex + 1] : undefined;
    try {
      const { rangeText } = await getQuestionRange(question, nextQuestionId, editSheet);
      await focusCell(rangeText, editSheet);
    } catch (error) {
      console.error("Error focusing on question:", error);
      // Optionally, you can handle the error here, e.g., show a notification
    }
  }

  const reviewsTarget = selectedId
    ? reviews[reviewState].find((i) => i.id == selectedId) || undefined
    : undefined;

  const { handleCommentOpen, handleCommentClose, commentOpen } = useCommentDialog();

  useEffect(() => {
    if (reviewsTarget && editSheet) {
      const questionIds = questions.map((q) => q.questionId);
      if (
        reviewsTarget.questionId &&
        (questionIds.includes(reviewsTarget.questionId) ||
          questionIds.includes(`Q${reviewsTarget.questionId}`))
      ) {
        const selectedQuestion = questions.find(
          (q) =>
            q.questionId === reviewsTarget.questionId ||
            q.questionId === `Q${reviewsTarget.questionId}`
        );
        selectedQuestion && setFocusOnQuestion(selectedQuestion, editSheet);
      } else if (reviewsTarget.target.includes("行目")) {
        const row = +reviewsTarget.target.replace("行目", "");
        focusCell(`B${row}:N${row}`, editSheet);
      } else {
        focusCell("B5", editSheet); // Fallback to a default cell if no specific question is found
      }
    }
  }, [reviewsTarget, editSheet]);

  return (
    <Stack flex={1}>
      <Typography variant="heading_M">{get(checkStateValues, reviewState, "")}</Typography>
      <Stack
        direction={"row"}
        spacing={2}
        alignItems={"center"}
        justifyContent={"space-between"}
        paddingX={2}
      >
        <Typography variant="body_M">{`${doneLength}/${reviews[reviewState].length - dismissLength} 確認済み`}</Typography>
        <Stack direction={"row"} alignItems={"center"} spacing={1}>
          {overalCommannds.map((obj, index) => (
            <MyIconButton
              key={index}
              icon={obj.icon}
              label={obj.label}
              clickFunction={obj.clickFunction}
              disabled={isExtraLoading || obj.disabled}
            />
          ))}
        </Stack>
      </Stack>
      <Stack flex={1} paddingX={1} direction={"column"}>
        <ResultsTable
          isExtraLoading={isExtraLoading}
          isFold={typeof selectedId == "string" && selectedId !== ""}
        />
        {isExtraLoading ? <LoadingBox2 text="追加のチェックをしています..." /> : <></>}
      </Stack>
      {selectedId ? (
        // <Stack flex={1} direction={"column"} justifyContent="flex-end">
        <ReviewDetailWindow handleCommentOpen={handleCommentOpen} />
      ) : (
        // </Stack>
        <></>
      )}
      <CommentDialog
        open={commentOpen}
        handleClose={handleCommentClose}
        handleClickOpen={handleCommentOpen}
      />
    </Stack>
  );
}

function useCommentDialog() {
  const [commentOpen, setCommentOpen] = useState<boolean>(false);

  function handleCommentOpen() {
    setCommentOpen(true);
  }

  function handleCommentClose() {
    setCommentOpen(false);
  }

  return { commentOpen, handleCommentOpen, handleCommentClose };
}
